import { FunctionComponent } from 'react'
import {
  MapsHomeWorkRounded,
  SolarPowerRounded,
  TopicRounded,
} from '@mui/icons-material'
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@black-bear-energy/rucksack'
import { useAuthSettings } from '../../state/modules/auth'
import { ReleaseSection } from './ReleaseSection'

export const ReleaseNotes: FunctionComponent = () => {
  const {
    settings: { enableSitesPage: showSitesExperienceCopy },
  } = useAuthSettings()

  return showSitesExperienceCopy ? (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <ReleaseSection
        section="new"
        icon={<MapsHomeWorkRounded fontSize="small" />}
        heading="Sites Experience"
      >
        <Typography>
          Structured around the Black Bear process, from RFP through
          energization. The Sites experience consolidates the data required to
          keep a project on track:
        </Typography>
        <List disablePadding sx={{ listStyleType: 'disc', paddingLeft: 3 }}>
          <ListItem sx={{ display: 'list-item', padding: 0 }}>
            <ListItemText primary="Project details and client requirements" />
          </ListItem>
          <ListItem sx={{ display: 'list-item', padding: 0 }}>
            <ListItemText primary="Estimated and actual timelines" />
          </ListItem>
          <ListItem sx={{ display: 'list-item', padding: 0 }}>
            <ListItemText primary="Progress against milestones" />
          </ListItem>
        </List>
        <Typography>
          Navigate via the Sites tab, then search, filter, or sort the table to
          locate a site.
        </Typography>
      </ReleaseSection>
      <ReleaseSection
        section="next"
        icon={<SolarPowerRounded fontSize="small" />}
        heading="Projects Experience"
      >
        <Typography>
          Next in the platform&apos;s roadmap, with additional releases
          scheduled throughout 2026.
        </Typography>
      </ReleaseSection>
    </Box>
  ) : (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <ReleaseSection
        section="new"
        icon={<TopicRounded fontSize="small" />}
        heading="Contracts in Document Exchange"
      >
        <Typography>
          Upload, share, and track legal documents in addition to the existing
          construction checklists directly within the platform.
        </Typography>
      </ReleaseSection>
      <ReleaseSection
        section="next"
        icon={<MapsHomeWorkRounded fontSize="small" />}
        heading="New Sites Experience"
      >
        <Typography>
          The new site overview is on deck, with two more releases planned
          throughout 2026. Stay tuned!
        </Typography>
      </ReleaseSection>
    </Box>
  )
}
